import { ButtonCustom, ButtonStyle } from './styles'
import React from 'react';

interface ButtonProps extends ButtonStyle {
  text: string
  onClick?: any
  color?: string
  type?: any
  disabled?: boolean
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  ref?: React.Ref<HTMLButtonElement> // Define ref prop
}

export const ButtonRef = React.forwardRef<HTMLButtonElement, ButtonProps>(({
  text,
  onClick,
  disabled,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  variantButton = 'default',
  backgroundColor = null,
  textColor = null,
  borderColor = null,
  type = 'button',
  width,
  hide = false,
  boxShadow,
  startIcon,
  endIcon
}: ButtonProps, ref) => (
  <ButtonCustom
    ref={ref} // Pass ref to ButtonCustom
    id={`${text}-${type}-${variantButton}`}
    startIcon={startIcon}
    endIcon={endIcon}
    onClick={onClick}
    marginTop={marginTop}
    marginBottom={marginBottom}
    marginLeft={marginLeft}
    marginRight={marginRight}
    variantButton={variantButton}
    backgroundColor={backgroundColor}
    textColor={textColor}
    borderColor={borderColor}
    type={type}
    width={width}
    hide={hide}
    boxShadow={boxShadow}
    disabled={disabled}
  >
    {text}
  </ButtonCustom>
))

ButtonRef.displayName = 'ButtonRef'; // Assign display name to the component
